import CourtsApiGateway from "../../interfaces/gateways/courts-api.gateway";
import MapRepository from "../../interfaces/gateways/map.repository";

export default class AddCourtToFavoriteCase {
  constructor (
    private readonly courtApi: CourtsApiGateway,
    private readonly mapRepo: MapRepository
  ) {
  }

  async execute (isFavorite: boolean): Promise<void> {
    const court = this.mapRepo.getSelectedCourt()
    if (isFavorite) {
      const response = await this.courtApi.getFavoriteLink(court.id)
      window.open(response.url, '_parent')
    } else {
      const response = await this.courtApi.getViewLInk(court.id)
      window.open(response.url, '_parent')
    }
  }
}
